module.exports = __webpack_public_path__ + "img/window-3.fe03c8b2.jpg";